export default __webpack_public_path__ + "static/media/banner_blog_6.ae35991c.png";